@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.orders-drawer-scrollable {
  overflow: auto;
  height: 100%;
  background-color: @containers--orders-drawer--background-color;

  & > div {
    padding-bottom: 100px;
    width: 100%;
  }
}
